import React from 'react'
import NumberFormat from 'react-number-format'

export default function PercentFormat(props) {
  const { inputRef, onChange, ...other } = props

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        if (Number(values.value) > 100) values.value = 100
        if (Number(values.value) < 0) values.value = 0
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        })
      }}
      thousandSeparator
      isNumericString
      decimalScale={2}
      suffix="%"
    />
  )
}
